/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import { Camera, Music } from 'lucide-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { formats, modules } from 'utils/config';
import { useFormContext } from 'react-hook-form';

function Editor() {
  const form = useFormContext();

  const [editorContent, setEditorContent] = useState<string>('');

  const getWordCount = (text: string): number => {
    const plainText = text.replace(/<[^>]*>/g, '');
    const words = plainText.trim().split(/\s+/);
    return words.filter(word => word.length > 0).length;
  };

  const wordCount = getWordCount(editorContent);

  useEffect(() => {
    form.setValue('content', editorContent);
  }, [editorContent]);

  return (
    <div id="Editor" className=" pt-6">
      {/* <button className="flex items-center border border-blue-400 text-blue-400 py-1 px-2 rounded hover:border-blue-950 hover:text-blue-950">
                <div className="flex items-center space-x-1 mr-2 relative">
                    <Camera className="w-4 h-4 mr-1" />{' '}   Add Media
                </div>
            </button> */}
      <div className="text-sm font-medium">Content</div>
      <div className="mt-3">
        <ReactQuill
          value={editorContent}
          onChange={setEditorContent}
          modules={modules}
          formats={formats}
          placeholder="Write your content here..."
        />
        <p className="text-gray-600 text-sm mt-2 text-right">
          <strong className="font-medium">Word Count:</strong> {wordCount}
        </p>
      </div>
    </div>
  );
}
export default Editor;
